import { Icon, Text } from "./base";

type AgentSessionRegionPillProps = {
  /** GCP region string from the session response, rendered as-is (e.g. "us-central1"). */
  region: string;
};

/** Where the session's engine pipeline ran. Informational — callers should
 *  render nothing when the session carries no servingRegion (older sessions,
 *  local dev). */
export const AgentSessionRegionPill = ({ region }: AgentSessionRegionPillProps) => {
  return (
    <Text className="w-auto px-2 py-0.5 rounded-full text-xs flex flex-row items-center gap-1 bg-sky-100 dark:bg-sky-900/20 text-sky-800 dark:text-sky-300">
      <Icon
        name="globe"
        size={11}
        className="mt-0.5 text-sky-800 dark:text-sky-300"
      />
      {region}
    </Text>
  );
};
